module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av587-2955bc7dceee146cd1ac6998ca3c8b0b.jpg";